function MaintenancePage() {
  return (
    <div style={{ textAlign: 'center', padding: '5rem', fontFamily: 'sans-serif' }}>
        <h1>🚧 Site under maintenance</h1>
        <p>We're experiencing technical difficulties. Our technical experts are fixing the issue.</p>
        <p>You can still reach us on <a href="mailto:hello@properize.com">hello@properize.com</a></p>
    </div>
  );
}

export default MaintenancePage;
